import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Crown } from 'lucide-react';

interface ProFeatureButtonProps {
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
}

const ProFeatureButton: React.FC<ProFeatureButtonProps> = ({ onClick, children, className = '' }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    navigate('/dashboard/subscription');
  };

  return (
    <button
      onClick={handleClick}
      className={`inline-flex items-center px-3 py-2 border border-line shadow-sm text-sm leading-4 font-medium rounded-md text-content-2 bg-surface hover:bg-surface-2 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 group ${className}`}
    >
      <Crown className="h-4 w-4 mr-2 text-yellow-500 group-hover:text-yellow-600 dark:text-yellow-400" />
      <span className="relative">
        {children}
        <span className="absolute -top-1 -right-1 flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-yellow-400 opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-yellow-500"></span>
        </span>
      </span>
    </button>
  );
};

export default ProFeatureButton;